import { JetView } from 'webix-jet';

/**
 * Class representing the details view for the bonus report.
 * @extends JetView
 */
export default class detailsBonusReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text',
                                    name: 'Id',
                                    label: _("<span class='icon-id'></span> ID"), // ID field with icon
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'), // Validation message
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Type',
                                    label: _('Tipo'), // Type field
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Date',
                                    label: _('Fecha'), // Date field
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'),
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Amount',
                                    label: _('Monto'), // Amount field
                                    labelPosition: 'top',
                                    placeholder: _('Monto'),
                                    disabled: true, // Field is disabled
                                    id: 'Monto', // ID for later reference
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout with multiview and scroll
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main],
        };

        // Narrow upper section layout
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Details window configuration
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                padding: 10,
                rows: [upper_section_narrow],
            },
        });

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formDetails',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Use upper section for larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'bonusTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for narrow view
            }
        });
    }
}

// FILE DOCUMENTED
